import React from "react"
import { generalSizeOrder } from "@/maps/centra-size-to-generic-size"
// Import the filter operation types
import Checkbox from "./Types/Checkbox"
import {
    Values,
    SearchFilter,
    ValuesFilterMeta
} from "@/lib/depict-client/types/api/ProductListingRequestV3"
import { filterConfig } from "@/app/(site)/_components/Organisms/ProductGrids/types/options"
import { FilterState } from "../filterReducer"

type FilterOptionsProps = {
    filter: SearchFilter | undefined
    selectedFilters: FilterState["filters"]
    setFilter: (
        field: string,
        op: string,
        value: string | string[] | number | number[],
        e: React.MouseEvent<HTMLDivElement>
    ) => void
}

const FilterOptions = ({ filter, selectedFilters, setFilter }: FilterOptionsProps) => {
    const onAddFilter = (
        field: string,
        op: SearchFilter["op"],
        value: string | string[],
        e: any
    ) => {
        setFilter(field, op, value, e)
    }

    // Size filter is handled differently because it has a transformation map
    const isSizeFilter = filter?.field === filterConfig[0].field
    const mapFilter = isSizeFilter
        ? generalSizeOrder
        : (filter?.meta as ValuesFilterMeta)?.values ?? []
    return mapFilter?.map((item, index) => {
        const selectedSizeOption = selectedFilters?.find(
            (option: { field: string }) => option.field === filter?.field
        )
        const isSelected = selectedSizeOption?.data?.includes(String(item)) ?? false

        return (
            <Checkbox
                valueIndex={index}
                isSizeFilter={isSizeFilter}
                filter={filter as SearchFilter}
                key={`${item}-${index}`}
                item={item as Values}
                field={filter?.field ?? ""}
                op={filter?.op as SearchFilter["op"]}
                isSelected={isSelected}
                onAddFilter={onAddFilter}
            />
        )
    })
}

export default FilterOptions
